var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#515151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.88 17.2905L14 13.4105L10.12 17.2905C10.0274 17.3831 9.9175 17.4565 9.79653 17.5066C9.67557 17.5567 9.54592 17.5825 9.41499 17.5825C9.28406 17.5825 9.15441 17.5567 9.03345 17.5066C8.91248 17.4565 8.80257 17.3831 8.70999 17.2905C8.61741 17.1979 8.54397 17.088 8.49386 16.967C8.44376 16.8461 8.41797 16.7164 8.41797 16.5855C8.41797 16.4546 8.44376 16.3249 8.49386 16.204C8.54397 16.083 8.61741 15.9731 8.70999 15.8805L13.3 11.2905C13.69 10.9005 14.32 10.9005 14.71 11.2905L19.3 15.8805C19.3927 15.973 19.4662 16.0829 19.5164 16.2039C19.5666 16.3248 19.5924 16.4545 19.5924 16.5855C19.5924 16.7165 19.5666 16.8461 19.5164 16.9671C19.4662 17.0881 19.3927 17.198 19.3 17.2905C18.91 17.6705 18.27 17.6805 17.88 17.2905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportUpArrow);
export default __webpack_public_path__ + "static/media/export-up-arrow.e2cf4d4d397c4a00ba85dc91c4fd4357.svg";
export { ForwardRef as ReactComponent };